import { faChevronRight } from '@fortawesome/pro-light-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { TiledLink } from '../../../shared/components/styledComponents/tiledLink/TiledLink';
import './MenuOptionLink.css';

type MenuOptionLinkProps = {
  icon: any;
  id: string;
  color?: string;
  text: string;
  to: string;
  isActive?: boolean;
  isNewTab?: boolean;
  className?: string;
  ariaLabel?: string;
};

export function MenuOptionLink({
  icon,
  id,
  color,
  text,
  to,
  isActive = false,
  isNewTab = false,
  className = '',
  ariaLabel,
}: MenuOptionLinkProps) {
  return (
    <TiledLink
      to={to}
      id={`profile-slider-link-${id}`}
      className={`profile-slider-link ${isActive ? 'active' : ''} ${className}`}
      isNewTab={isNewTab}
      ariaLabel={ariaLabel || text}
    >
      <div className="menu-item" aria-hidden="true">
        <FontAwesomeIcon icon={icon} style={{ color }} className="slider-icon" />
        <div className="slider-text" id={`profile-slider-link-${id}`}>
          {text}
        </div>
      </div>
      <FontAwesomeIcon icon={faChevronRight} className="slider-chevron" aria-hidden="true" />
    </TiledLink>
  );
}
